/**
 * Converts the given string from camel case to kebab case (givenExampleString => given-example-string)
 *
 * @param string string to be convert from camelCase to kebab-case
 */
export function camelToKebabCase(string: string = ''): string {
	return string.replace(/([A-Z])/g, (caps) => `-${caps[0].toLowerCase()}`);
}
